<template>
  <div
    v-if="data && data.child"
    class="member-module"
  >
    <div
      v-for="(item, index) in data.child"
      :key="index"
      class="clearfix"
    >
      <div
        v-if="item.fieldkey !== 'group' || joinTeamCascaderShow"
        class="validator-item border-bottom-1px"
      >
        <label :data-require="item.isneeded && item.fieldtype === 'cascader' ? true : false">{{ item.fieldname }}</label>

        <div class="fieldValue">
          <template
            v-if="item.fieldtype === 'string'"
            class="fieldValue"
          >
            <div
              v-if="item.fieldkey === 'dev' || item.fieldkey === 'follow'"
              :label="item.fieldname"
            >
              <span class="truename">
                <em v-if="item.fieldkey === 'follow'">
                  <span v-if="item.info.status === 0">{{ $t('message["394"]') }}</span>
                  <span v-else-if="item.info.status === 2 || item.info.status === 4">{{ $t('message["139"]') }}</span>
                  <span v-else-if="item.info.status === 3">{{ $t('message["146"]') }}</span>
                  <span v-else>{{ item.info.truename || '- -' }}</span>
                </em>
                <em v-else>{{ item.info.truename || '- -' }}</em>
              </span>
              <!-- group -->
              <span
                v-if="item.info.rolename || item.info.groupname"
                class="fs-gray ml-8"
              >[<em class="rolename">{{ item.info.rolename || '--' }}</em> <em v-if="item.info.groupname && item.info.rolename">/</em> <em class="groupname">{{ item.info.groupname || '' }}</em>]</span>
            </div>
            <not-can-edit-item
              v-else
              :data="item"
            />
          </template>
          <!-- 跟进人员-多级选择 -->
          <template v-else-if="item.fieldkey === 'follow'">
            <my-cascader
              ref="followCascader"
              :value="currentFollowValue"
              :data="item"
              :async="true"
              :get-data="getData"
              :input-truename="inputTruename"
              @change="handleChange($event, item.fieldkey)"
            >
              <a-checkbox
                v-if="enableshare"
                slot="before"
                class="border-top-1px"
                :checked="isShared"
                :disabled="disabledShare"
                @change="onChangeShare(item, $event)"
              >
                {{ $t('message["1725"]') }}
              </a-checkbox>

              <div
                v-if="assignTeamInfo.length"
                slot="after"
                class="relate-list"
              >
                <p v-if="!isBeiAn">
                  {{ $t('message["1456"]') }}{{ followTxt }}：
                </p>
                <a-radio-group
                  v-model="assignRelateValue"
                  @change="onChangeAssignRelate(item)"
                >
                  <a-radio
                    v-for="info in assignTeamInfo"
                    :key="`${info.roleid}-${info.groupid}-${info.userid}`"
                    :value="info.id"
                  >
                    <span v-if="info.rolename">{{ info.rolename }}</span>
                    <span v-if="info.groupname">/{{ info.groupname }}</span>
                    <!-- 分配方式文案 -->
                    <span v-if="info.divide_type && info.type_num == 2">/{{ divides[info.divide_type] }}</span>
                    <span v-if="info.truename"><em v-if="info.groupname">/</em>{{ info.truename }}</span>
                  </a-radio>
                </a-radio-group>
              </div>
            </my-cascader>
          </template>
          <!-- 开发人员-多级选择 -->
          <template v-else-if="item.fieldkey === 'dev'">
            <my-cascader
              ref="devCascader"
              :value="currentDevValue"
              :data="item"
              :async="true"
              :get-data="getData"
              :input-truename="inputTruename"
              @change="handleChange($event, item.fieldkey)"
            >
              <div
                v-if="relateTeamInfo.length && !(currentDevValue.length && currentDevValue[0].id=== 'null')"
                slot="after"
                class="relate-list"
              >
                <p>{{ $t('message["1457"]') }}：</p>

                <a-radio-group
                  v-model="relateValue"
                  @change="onChangeRelate(item)"
                >
                  <a-radio
                    v-for="info in relateTeamInfo"
                    :key="`${info.roleid}-${info.groupid}-${info.userid}`"
                    :value="info.id"
                  >
                    <span v-if="info.rolename">{{ info.rolename }}</span>
                    <span v-if="info.groupname">/{{ info.groupname }}</span>
                    <span v-if="info.truename">/{{ info.truename }}</span>
                  </a-radio>
                </a-radio-group>
              </div>
            </my-cascader>
          </template>
          <!-- 所属团队小组-多级选择 -->
          <my-cascader
            v-else-if="item.fieldkey === 'group'"
            ref="groupCascader"
            :value="currentGroupValue"
            :data="item"
            :get-data="getData"
            @change="handleChange($event, item.fieldkey)"
          />
          <my-cascader
            v-else
            :data="item"
            :get-data="getData"
            @change="handleChange($event, item.fieldkey)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getJoinTeamInfo, getAuthTeamInfo } from '@/services/index'
import MyCascader from '@/components/mobile/formItem/Cascader2'
import NotCanEditItem from '@/components/mobile/formItem/NotCanEdit'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    MyCascader,
    NotCanEditItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      joinTeamCascaderShow: true,
      relateValue: '',
      assignRelateValue: '',
      disabledShare: false,
      isShared: this.data.is_shared || false,
      currentDevValue: [],
      currentGroupValue: [],
      currentFollowValue: [],
      // joinTeamCascaderInfo: {},
      $groupCascader: null,
      divides: {
        1: this.$t('message["299"]'), // 分配到人
        2: this.$i18n.t('message["714"]'), // 平均分配
        3: this.$i18n.t('message["3"]'), // 按额度分配
        4: this.$i18n.t('message["1763"]') // 负责人指派
      }
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/detailData', ['isBeiAn']),
    ...mapState('inquery/relateData', ['relateTeamInfo', 'assignTeamInfo']),
    ...mapGetters('inquery/detailData', ['memberInfo']),
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    from () { // all, my, audit, checkrepeat
      if (this.$route.name === 'InqueryCreate') { // 录入信息
        return 'input'
      } else { // 信息详情
        return this.$route.query.from
      }
    },
    isCreatePage () {
      return this.$route.name === 'InqueryCreate'
    },
    isAuditPage () {
      return this.$route.name === 'InqueryDetail' && this.auditStatus !== 1
    },
    followTxt () {
      const { currentFollowValue } = this
      const type = currentFollowValue.find(item => { if (item.keyname === 'divide_type') { return item.id } })
      if (type) {
        return type * 1 === 1 ? this.memberGroup[0] : this.memberGroup[1]
      } else {
        return this.memberGroup[0]
      }
    },
    memberGroup () {
      return this.$t('message["932"]').split('|')
    },
    inputTruename () {
      let inputTruename
      this.data.child.forEach((child = {}) => {
        if (child.fieldkey === 'input') {
          inputTruename = child.fieldvalue || ''
        }
      })
      return inputTruename
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    }
  },

  watch: {
    relateTeamInfo: {
      handler (val) {
        /* val = [{
          userid: 100015,
          name: 'huang'
        }] */
        this.relateValue = ''
        this.currentDevValue = []
        // 如果查询出的开发人员只有一条数据，默认选上
        this.data.child.forEach((item, i) => {
          if (item.fieldtype === 'cascader' && item.fieldkey === 'dev') {
            if (val.length === 1) {
              item.info = val[0]
              item.fieldvalue = this.setDefaultValue(item)
              this.currentDevValue = item.fieldvalue
              this.relateValue = val[0].id
            } else if (val.length > 1) {
              item.info = {}
              item.fieldvalue = []
              this.relateValue = ''
              this.currentDevValue = []
            } else if (val.length === 0) {
              item.fieldvalue = this.setDefaultValue(item)
              this.currentDevValue = item.fieldvalue
              this.relateValue = ''
            }
            this.data.child.splice(i, 1, item)
            // this.$forceUpdate()
            this.$emit('change', item)
          }
        })
      },
      deep: true
      // immediate: true
    },
    assignTeamInfo: {
      handler (val) {
        this.assignRelateValue = ''
        if (!val || !val.length) return
        // 如果查询出的跟进人员只有一条数据，默认选上
        this.data.child.forEach((item, i) => {
          if (item.fieldtype === 'cascader' && item.fieldkey === 'follow') {
            // 如果查询出的跟进人员只有一条数据，默认选上这条关联人员
            if (val.length === 1) {
              item.info = val[0]
              item.fieldvalue = this.setDefaultValue(item)
              this.currentFollowValue = item.fieldvalue
              this.assignRelateValue = val[0].id
            } else if (val.length > 1) {
              item.info = {}
              item.fieldvalue = []
              this.currentFollowValue = [] // 关联到的数据长度为0，或者大于1，清空选择
            } else if (val.length === 0) {
              item.fieldvalue = this.setDefaultValue(item)
              this.currentFollowValue = item.fieldvalue
              this.relateValue = ''
            }

            this.data.child.splice(i, 1, item)
            this.$emit('change', item)
          }
        })
        this.$forceUpdate()
      },
      deep: true
      // immediate: true // 去掉，勿改
    },
    data: {
      handler (val) {
        let { child = [] } = val || {}
        for (let item of child) {
          if (item.fieldtype === 'string' && item.fieldkey === 'inputName') {
            if (!item.fieldvalue) {
              item.fieldvalue = this.baseinfo && this.baseinfo.truename
            }
          } else if (item.fieldkey === 'group') {
            if (this.baseinfo && this.baseinfo.system_role === 1) {
              item.isneeded = 0
            } else {
              item.isneeded = 1
            }
          } else if (item.fieldkey === 'dev' && item.isBeiAn) {
            this.currentDevValue = item.fieldvalue
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  async created () {
    eventBus.$on('updateFollowShare', this.updateFollowShare)
    eventBus.$on('clearCascaders', this.clearCascaders)

    // 审核页面
    if (this.$route.name === 'InqueryDetail' && this.auditStatus !== 1) {
      if (this.isBeiAn) { // 默认选择了备案时
        this.updateFollowShare(this.isBeiAn, true)
      }

      // 跟进人员有默认值时
      this.data.child.forEach((item, i) => {
        if (item.fieldtype === 'cascader') {
          item.fieldvalue = this.setDefaultValue(item)
          if (item.fieldkey === 'follow') {
            this.currentFollowValue = item.fieldvalue
          } else if (item.fieldkey === 'dev') {
            this.currentDevValue = item.fieldvalue
          }
        }
      })
    }
  },

  methods: {
    ...mapMutations('inquery/detailData', ['updataJoinTeamCascaderShow']),
    /**
     * 获取成员组件的 option 数据
     * obj [Object] 请求接口的参数，包含type 或 pk
     */
    async getData (obj = {}) {
      let { fieldkey, type } = obj
      let params = {}
      let result
      if (type) { // 共享
        params.type = type
      }
      if (fieldkey === 'group') { // 所属团队小组
        if (this.auditStatus === 0 || this.auditStatus === -1 || this.from === 'audit') {
          params.pk = 'inquiry-audit'
        } else {
          params.pk = 'inquiry-add'
        }

        result = await getJoinTeamInfo()
          .params(params).fetch()
      } else if (fieldkey === 'dev') { // 开发人员
        params.pk = 'inquiry-dev'
        params.deal = 1 // 去除空组和空团队

        result = await getAuthTeamInfo()
          .params(params).fetch()
      } else if (fieldkey === 'follow') { // 跟进人员
        params.pk = 'inquiry-followup'

        if (!this.isShared && !this.isBeiAn) {
          params.divide = 1 // 出现四列
        }

        if (!this.isShared) {
          params.deal = 1 // 去除空组和空团队
        }
        // 审核页面，如果选择了共享，并且共享开启type=1
        if (this.isShared && this.enableshare) {
          params.type = 1
        }

        result = await getAuthTeamInfo()
          .params(params).fetch()
      }

      let { payload: data = [] } = (result && result.data) || {}

      if (fieldkey === 'group') {
        this.joinTeamCascaderShow = !!data.length
        this.updataJoinTeamCascaderShow(this.joinTeamCascaderShow)

        // 如果所属团队与小组人员只有一条数据，默认选上
        if (data.length === 1 && data[0].children && data[0].children.length === 1) {
          this.data.child.forEach((item, i) => {
            if (item.fieldkey === 'group' && item.fieldvalue.length < 2) {
              let res = {}
              item.info = this.setFirstAsValue(res, data[0])

              item.fieldvalue = this.setDefaultValue(item)

              this.currentGroupValue = item.fieldvalue

              // this.joinTeamCascaderInfo = item.info

              // this.data.child.splice(i, 1, item)
              // eventBus.$emit('getMemberInfo', this.data)
              this.$emit('change', item)
            }
          })
          this.$forceUpdate()
        }

        this.$forceUpdate()
      }
      /* else if (fieldkey === 'dev') {
        // 开发人员过滤空组
        this.setGroupEmpty(data)
        this.setRoleEmpty(data)
      } else if (fieldkey === 'follow') {
        if (this.isBeiAn) {
          // 如果跟进人员，选择了备案，即使再选择共享，还是可以选择到人
          this.setGroupEmpty(data)
          this.setRoleEmpty(data)
        }
        if (!this.isShared) {
          this.setDivideGroupEmpty(data)
        }
        if (!this.isBeiAn && !this.isShared) {
          // 如果没有选备案，也没选共享，需要判断分配方式
          this.setFollowData(data)
        }
      } */
      if (fieldkey === 'dev') {
        data = [{
          id: 'null',
          keyname: 'roleid',
          name: '-无-'
        }].concat(data)
      }
      if (fieldkey === 'follow' && !this.isBeiAn && !this.isShared) {
        // 如果没有选备案，也没选共享，需要判断分配方式
        this.setFollowData(data)
        data = [{
          id: 'null',
          keyname: 'roleid',
          name: '-暂不分配-'
        }].concat(data)
      }

      return data
    },

    /**
     * 设置第一项的数据为value
     */
    setFirstAsValue (res = {}, data = {}) {
      if (data.keyname) {
        res[data.keyname] = data.id
        res[data.keyname.substring(0, data.keyname.length - 2) + 'name'] = data.name
      }

      if (data.children && data.children.length) {
        this.setFirstAsValue(res, data.children[0])
      }
      return res
    },

    /* 每一项操作后把值传到父级 */
    handleChange (data, fieldkey) {
      this.$emit('change', data)
      if (fieldkey === 'dev') {
        this.relateValue = ''
      }
      this.$refs.groupCascader[0].validate()
    },

    /**
     * 当分配方式是1，选到人，不是1，删除掉人的 children 数据
     */
    setFollowData (data) {
      for (let item of data) {
        if (item.hasOwnProperty('divide_type') && item.divide_type.length === 1 && item.divide_type[0] !== 1) {
          item.children = []
        }
        if (item.children && item.children.length) {
          this.setFollowData(item.children)
        }
      }
    },

    /**
     * 当选择了备案，忽略分配方式，并且置灰(删除)没有人的组
     */
    setGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'groupid' && (!item.children || !item.children.length)) {
          // item.disabled = true
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setGroupEmpty(item.children)
        }
      }
    },
    setRoleEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'roleid' && (!item.children || !item.children.length)) {
          data.splice(i, 1)
        }
      }
    },
    /**
     * 置灰(删除) divide_type 为 1 的 空组
     */
    setDivideGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'groupid' && item.divide_type.length === 1 && item.divide_type[0] === 1 && (!item.children || !item.children.length)) {
          // item.disabled = true
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setDivideGroupEmpty(item.children)
        }
      }
    },

    onChangeShare (item, e) {
      this.isShared = e.target.checked
      this.data.is_shared = this.isShared
      this.updateFollowOptions(item, this.isShared)
    },

    /**
     * 切换选择到组和人的数据
     * 信息类型切换，会引起备案的变化，备案变化，小组共享会显示或隐藏 ==> 之前选择的跟进人员下拉接口会重新请求，已选的跟进人员会被清空
     */
    updateFollowOptions (item, isShared) {
      this.$nextTick(async () => {
        if (this.$refs.followCascader && this.$refs.followCascader[0]) {
          this.$refs.followCascader[0].clearCascader()
          item.info = {}
          item.fieldvalue = []

          let type = isShared ? 1 : 0
          let data = await this.getData({ fieldkey: 'follow', type })
          item.options = data
          this.$refs.followCascader[0].updateFollowOptions(data, isShared)
        }
      })
    },
    onChangeRelate (item) {
      this.relateTeamInfo.forEach(info => {
        if (info.id === this.relateValue) {
          item.fieldvalue = this.setDefaultValue({ info })
          item.info = info
          this.currentDevValue = item.fieldvalue
        }
      })
    },
    onChangeAssignRelate (item) {
      this.assignTeamInfo.forEach(info => {
        if (info.id === this.assignRelateValue) {
          item.fieldvalue = this.setDefaultValue({ info })
          item.info = info
          this.currentFollowValue = item.fieldvalue
        }
      })
    },
    /**
     * 处理默认value值
     */
    setDefaultValue (item = {}) {
      let arr = []
      const { info = {}, fieldkey } = item
      const { divides } = this
      let { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, truename = '', rolename = '', groupname = '' } = info

      // 如果是审核页面
      // 审核页的录入人员不是万能表单
      if ((this.isAuditPage && this.inputTruename.indexOf('万能表单自动录入') === -1) && !roleid && !userid) {
        roleid = 'null'
        rolename = fieldkey === 'dev' ? '-无-' : fieldkey === 'follow' ? '-暂不分配-' : ''
      }
      if (roleid) {
        arr.push({
          keyname: 'roleid',
          id: roleid,
          name: rolename
        })
      }
      if (groupid) {
        arr.push({
          keyname: 'groupid',
          id: groupid,
          name: groupname
        })
      }

      if (divideType === 1 && userid) {
        arr.push({
          keyname: 'divide_type',
          id: divideType,
          name: divides[divideType]
        })
        arr.push({
          keyname: 'userid',
          id: userid,
          name: truename
        })
      } else if (userid && !divideType) {
        arr.push({
          keyname: 'userid',
          id: userid,
          name: truename
        })
      } else if (divideType) {
        arr.push({
          keyname: 'divide_type',
          id: divideType,
          name: divides[divideType]
        })
      }

      this.data.fieldvalue = arr
      return arr
    },
    /**
     * val: 是否选择了备案
     * type: 如果审核页面默认选择了备案，type = true，如果点击共享选择，type 为 undefind
     *
     * 选择了备案，清空选择的共享，数据
     */
    updateFollowShare (val, type) {
      if (val) {
        this.isShared = false
        this.data.is_shared = false
        this.disabledShare = true
      } else {
        this.disabledShare = false
      }

      if (!type) { // 手动点击共享时，才清空跟进人员选择的结果
        const { child = [] } = this.data
        const item = child.find(item => item.fieldkey === 'follow')
        this.updateFollowOptions(item, false)
        this.assignRelateValue = ''
        this.$forceUpdate()
      }
    },

    clearCascaders (key) {
      this.data.child.forEach((item, i) => {
        if (item.fieldkey === key) {
          item.info = {}
          item.fieldvalue = []
        }
        if (key === 'dev') {
          this.currentDevValue = []
        }
        if (key === 'group') {
          this.currentGroupValue = []
        }
      })
    },

    validateMember () {
      const keys = Object.keys(this.$refs).filter(key => key.indexOf('Cascader') !== -1)
      const { length } = keys
      let memberError = false
      for (let i = 0; i < length; i++) {
        const id = keys[i]
        const ref = this.$refs[id][0] || {}
        const { isneeded } = ref.data || {}
        if (ref && ref.validate && isneeded) {
          ref.validate((result) => {
            console.log('member', result, ref.data)
            if (result === false) {
              memberError = true
              this.scrollToErrorEle(ref)
            }
          })
        }
      }

      return memberError
    },
    scrollToErrorEle (ref) {
      let ele = ref.$el
      ele.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.member-module {
  ::v-deep .ant-checkbox-wrapper {
    width: 100%;
    margin-right: 16px;
  }
  ::v-deep .ant-radio-wrapper {
    display: block;
  }
  .share-text {
    margin-bottom: 16px;
    line-height: 24px;
  }
  em {
    font-style: normal;
  }
  ::v-deep .cascader {
    .relate-list {
      margin-left: -88px;
      p {
        color: #888;
      }
    }
  }
}
</style>
